<template>
    <section class="account" id="account">
        <div class="container vld-parent">
            <loading :active.sync="isLoading" :background-color="'#000'" :color="'#ecd19a'" :opacity="0.7"></loading>
            <div class="row">
                <h2>My Account</h2>
                <div class="account-container">
                    <div class="space-below">
                        <div class="card">
                            <div class="card-header">
                                Server Status
                            </div>
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-xs-6">Live:</div>
                                    <div class="col-xs-6"><span :class="'badge badge-'+ status.live">{{ status.live }}</span></div>
                                </div>
                                <div class="row">
                                    <div class="col-xs-6">Test:</div>
                                    <div class="col-xs-6"><span :class="'badge badge-'+ status.test">{{ status.test }}</span></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-8">
                        <div class="card">
                            <div class="card-header">
                                Account Details
                            </div>
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-xs-4">Username:</div>
                                    <div class="col-xs-4">{{ this.$currentUser.username }}</div>
                                </div>
                                <div v-if="isActive" class="row">
                                    <div class="col-xs-4">Steam:</div>
                                    <div v-if="isLinked" class="col-xs-8"><a href="#" class="troubleText" @click="gotoSteamLink()" >View linked account</a></div>
                                    <div v-else class="col-xs-8">
                                        <a href="#" class="troubleText" @click="openModal()" >Link My Steam Account</a>
                                    </div>
                                </div>
                                <div v-if="isActive && isLinked && hasSteamKey" class="row">
                                    <div class="col-xs-4">Steam Key:</div>
                                    <div class="col-xs-8"><a href="#" class="troubleText" @click="openKeyModal()" >Redeem steam key</a></div>
                                </div>
                                <div class="row">
                                    <div class="col-xs-4">Account Status:</div>
                                    <div class="col-xs-8"><span :class="'badge badge-'+ accStatus">{{ accStatus }}</span> <span v-if="isGM" class="badge badge-gm">gm</span></div>
                                </div>
                                <div v-if="account.isSuspended" class="row">
                                    <div class="col-xs-4">&nbsp;</div>
                                    <div class="col-xs-8">Account is supended until {{ dtFormat(account.suspension_End) }}</div>
                                </div>
                                <div class="account-container" style="padding: 1em;">
                                    <button class="outline-btn" @click="gotoPwReset" >Forgot Password?</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div  v-if="isGM" class="game-container">
                <div class="col-xs-10">
                    <Downloads title="GM Downloads" :urls="status.gm"></Downloads>                   
                </div>
            </div>
            <div class="game-container"> 
                <div class="col-xs-10">
                    <div class="card">
                        <div class="card-header">
                            Download Embers Adrift
                        </div>
                        <div class="card-body">
                            <div class="desktop">
                                <div class="row">
                                    <div class="centered">
                                        <div style="padding-bottom: 32px;">Embers Adrift is now available on Steam!</div>
                                        <div  style="padding-bottom: 32px;"><a href="https://store.steampowered.com/app/3336530/Embers_Adrift/" alt="Embers Adrift on Steam"><img src="@/assets/img/steam.png" /></a></div>
                                    </div>
                                </div>
                                <div v-if="isActive && isLinked && hasSteamKey" class="center-button">
                                    <a xmlns="http://www.w3.org/1999/xhtml" class="button-game" @click="openKeyModal()" href="#">
                                            <span class="button-game-bg-left"></span>
                                            <span class="button-game-bg-mid">
                                                <span class="subscribe">Redeem on Steam</span>
                                            </span>
                                            <span class="button-game-bg-right"></span>
                                        </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            <div class="row" >
                <div class="center-button">
                    <a xmlns="http://www.w3.org/1999/xhtml" class="button-game" @click="onSubscribeClick" href="#">
                            <span class="button-game-bg-left"></span>
                            <span class="button-game-bg-mid">
                                <span class="subscribe">Subscribe to our Newsletter</span>
                            </span>
                            <span class="button-game-bg-right"></span>
                        </a>
                </div>
            </div> 
        </div>
        <b-modal ref="steam-modal" hide-footer hide-header centered content-class="modal-content">
            <span class="Video-border Video-border--top"></span>
            <span class="Video-border Video-border--right"></span>
            <span class="Video-border Video-border--bottom"></span>
            <span class="Video-border Video-border--left"></span>
            <span class="Video-corner Video-corner--topLeft"></span>
            <span class="Video-corner Video-corner--topRight"></span>
            <span class="Video-corner Video-corner--bottomRight"></span>
            <span class="Video-corner Video-corner--bottomLeft"></span>
            <div class="modal-header pattern">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeModal"><span aria-hidden="true">&times;</span></button>
                <h4 class="modal-title" id="myModalLabel">Steam Link</h4>
            </div>
            <div class="modal-body pattern-dark clearfix" id="modalBody">
                <div v-if="atStep2" style="color:#ecd19a; padding: 16px;">
                    <p><span style="font-weight: bold;">Step two</span></p>
                    <p>Permanently link your local game account to your Steam account by clicking below</p>
                    <p>This process is not reversible</p>
                    <div><a href="#" class="troubleText" @click="gotoXFSteamLink()" >View Steam account to be linked</a></div>
                    <p style="font-size: smaller; padding-top: 12px;">If you have already purchased Embers Adrift you will find your steam key on this page after completing this step</p>
                </div>
                <div v-else style="color:#ecd19a; padding: 16px;">
                    <p>To login via Steam after the migration<br />You will need to link your Steam account</p>
                    <p><span style="font-weight: bold;">Step one</span><br />Link your forum account to your Steam Account.</p>
                    <p>Once completed, return here for the final step!</p>
                </div>
            </div>
            <div class="modal-footer pattern">
                <div style="margin-bottom: 32px;">
                    <a xmlns="http://www.w3.org/1999/xhtml"  @click="onSteamClick" class="button-game" style="cursor: pointer;">
                        <span class="button-game-bg-left"></span>
                        <span class="button-game-bg-mid">
                            <span v-if="atStep2">Link My Embers Account</span>
                            <span v-else>Link my Forum Account</span>
                        </span>
                        <span class="button-game-bg-right"></span>
                    </a>
                </div>
            </div>
        </b-modal>
        <b-modal ref="steam-key-modal" hide-footer hide-header centered content-class="modal-content">
            <span class="Video-border Video-border--top"></span>
            <span class="Video-border Video-border--right"></span>
            <span class="Video-border Video-border--bottom"></span>
            <span class="Video-border Video-border--left"></span>
            <span class="Video-corner Video-corner--topLeft"></span>
            <span class="Video-corner Video-corner--topRight"></span>
            <span class="Video-corner Video-corner--bottomRight"></span>
            <span class="Video-corner Video-corner--bottomLeft"></span>
            <div class="modal-header pattern">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeModal"><span aria-hidden="true">&times;</span></button>
                <h4 class="modal-title" id="myModalLabel">Redeem Steam Key</h4>
            </div>
            <div class="modal-body pattern-dark clearfix" id="modalBody">
                <div style="color:#ecd19a; padding: 16px;">
                    <p>This is your Steam Key. It is attached to your legacy account and will add Embers Adrift to your Steam Library once redeemed.</p>
                    <p><span style="font-weight: bold;">This key can only be used once</span></p>
                    <p>{{ account.steamKey }}</p>
                    <p style="font-size: smaller; padding-top: 12px;">Use the button below to redeem your key or by opening the Steam App and click 'Add a Game' in the bottom left corner then select 'Activate a product on Steam'</p>
                </div>
            </div>
            <div class="modal-footer pattern">
                <div style="margin-bottom: 32px;">
                    <a xmlns="http://www.w3.org/1999/xhtml"  @click="gotoSteamRedeem" class="button-game" style="cursor: pointer;">
                        <span class="button-game-bg-left"></span>
                        <span class="button-game-bg-mid">
                            <span>Redeem on Steam</span>
                        </span>
                        <span class="button-game-bg-right"></span>
                    </a>
                </div>
            </div>
        </b-modal>
    </section>
</template>
<script>
    import Downloads from '../components/downloads.vue';
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    import moment from 'moment';

    export default {
        name: 'AccountComponent',
        components: { Downloads, Loading },
        data() {
            return {
                isLoading: false,
                shopOpen: this.$config.shop_open,
                openPlay: this.$config.open_play,
                account: {},
                status: {}
            }
        },
        watch:{
            '$config' () {
                this.shopOpen = this.$config.shop_open;
                this.openPlay = this.$config.open_play;
            }
        },
        methods: {
            dtFormat(dt) { 
                if (dt) {
                    return moment.utc(String(dt)).local().format('L LT'); 
                } else {
                    return "";
                }
            },
            getData(){
                this.isLoading = true;
                this.axios.get(this.$config.api_url + "/My/Account", { withCredentials: true }).then((response) => {
                    this.account = response.data.user;
                    this.status = response.data.clientInfo;
                    this.isLoading = false;
                }).catch(() =>  {
                    this.$toast.error('Error Retrieving Account, Please Try again');
                    this.isLoading = false; 
                });
            },
            onSubscribeClick(event) {
                if (event) {
                    event.preventDefault();
                }
                this.$router.push('Newsletter');
            },
            openModal() {
                this.closeModal();
                this.$refs['steam-modal'].show();
            },
            closeModal() {
                this.$refs['steam-modal'].hide();
            },
            onSteamClick() {
                this.$refs['steam-modal'].hide();

                if (!(this.account.xfSteamId)) {
                    window.location = 'https://forums.embersadrift.com/index.php?account/connected-accounts/';
                } else {
                    this.syncSteam(); 
                }
                
            },
            syncSteam(){
                this.isLoading = true;
                this.axios.post(this.$config.api_url + "/My/SteamLink", '', { withCredentials: true }).then((response) => {
                    this.account = response.data.user;
                    this.status = response.data.clientInfo;
                    this.isLoading = false;
                    this.$toast.success('Steam Account Linked!');
                }).catch((error) => {
                    this.$toast.error(error.response.data.err);
                    this.isLoading = false; 
                });
            },
            openKeyModal() {
                this.$refs['steam-key-modal'].show();
            },
            gotoPwReset() {
                window.location = 'https://forums.embersadrift.com/index.php?account/security';
            },
            gotoSteamLink() { 
                window.open(
                    'http://steamcommunity.com/profiles/' + this.account.steamId,
                    '_blank'
                );
            },
            gotoXFSteamLink() { 
                window.open(
                    'http://steamcommunity.com/profiles/' + this.account.xfSteamId,
                    '_blank'
                );
            },
            gotoSteamRedeem() { 
                window.open(
                    'https://store.steampowered.com/account/registerkey?key=' + this.account.steamKey,
                    '_blank'
                );
            }
        },
        computed: {
            accStatus: function () {
                if (this.account.isSuspended) {
                    return "suspended";
                } else if ((this.account.flags & 1) > 0) {
                    return "active";
                } else {
                    return "inactive";
                }
            },
            tier: function() { 
                    if (this.account.product_Key){
                        return(this.account.product) ? this.account.product : "N/A" ; 
                    } else if (this.openPlay) {
                        return "Free Trial";
                    } else {
                        return "Purchase to Join Today!";
                    }
            },
            isActive: function () { return (this.account.flags & 1) > 0; },
            isGM: function () { return (this.account.flags & 2) > 0; },
            isLinked: function () { return (this.account.steamId) },
            atStep2: function () { return (this.account.xfSteamId) },
            hasSteamKey: function () { return (this.account.steamKey) }
        },
        created() {
            this.getData();
        }
    }
</script> 